import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Logo as LogoIcon } from 'common/components/svgs';

const Footer = ({ t }) => (
  <footer className="footer">
    <div className="footer__container">
      <Link to="/" className="footer__logo">
        <LogoIcon className="footer__icon" />
      </Link>
      <ul className="footer__list">
        <li className="footer__item">
          <a className="footer__link" href="//www.student.com/terms/cookies">
            {t('landlord.footer.links.cookies')}
          </a>
        </li>
        <li className="footer__item">
          <a className="footer__link" href="//www.student.com/terms/privacy">
            {t('landlord.footer.links.privacy')}
          </a>
        </li>
        <li className="footer__item">
          <a className="footer__link" href="//www.student.com/terms/terms-of-use">
            {t('landlord.footer.links.terms')}
          </a>
        </li>
        <li className="footer__item">
          {t('landlord.footer.links.copyright', { year: moment().format('YYYY') })}
        </li>
      </ul>
    </div>
  </footer>
);

Footer.propTypes = {
  t: PropTypes.func.isRequired,
};

Footer.defaultProps = {
  t: () => {},
};

export default withTranslation()(Footer);
